<template>
  <div class="setting">
    <Nav :subNav="'查看介绍'" :isShowBack="1"></Nav>

    <div class="help-wrap">
      <div class="back-wrap" @click="goBack">
        <div class="back-icon"></div>
        返回
      </div>
      <div class="help-middle-wrap">
        <img :src="require('../assets/setting/desc-bg.png')" />
        <!-- <div class="help-left-wrap">
					<div class="left-01">
						<div class="left-01-title">内网穿透 一键远程</div>
					</div>
					<div class="left-04">
						<div class="left-04-line"></div>
						<div class="left-04-title">远程管理多设备</div>
						<div class="left-04-item-wrap">
							<div>
								<div class="left-04-item left-04-item-01">
									远程桌面
								</div>
								<div class="left-04-item-line"></div>
								<div class="left-04-item left-04-item-02">
									NAS管理
								</div>
								<div class="left-04-item-line"></div>
								<div class="left-04-item left-04-item-03">
									路由管理
								</div>
							</div>
							<div class="left-04-item left-04-item-04">
								远程办公
							</div>
							<div class="left-04-item-line"></div>
							<div class="left-04-item left-04-item-05">
								文件传输
							</div>
							<div class="left-04-item-line"></div>
							<div class="left-04-item left-04-item-06">
								远程打印
							</div>
						</div>
					</div>
					<div class="left-right">
						<div class="left-02">
							<div class="left-02-line"></div>
							<div class="left-02-title">
								一台安装<br />服务全网
							</div>
							<div class="left-02-desc"></div>
						</div>
						<div class="left-03">
							<div class="left-03-line"></div>
							<div class="left-03-title">一键唤醒</div>
							<div class="left-03-desc"></div>
						</div>
					</div>
				</div>
				<div class="help-right-wrap">
					<div class="right-01">
						<div class="right-01-title">无需配置<br />开启即用</div>
					</div>
					<div class="right-02">
						<div class="right-02-line"></div>
						<div class="right-02-title">安全高效</div>
					</div>
					<div class="right-03">
						<div class="right-03-line"></div>
						<div class="right-03-title">轻松管理</div>
					</div>
				</div> -->
      </div>
      <!-- <div class="more-jdxb" @click="goHelp">
				<div class="more-icon"></div>
				<div class="more-text">了解更多></div>
			</div> -->
    </div>
  </div>
</template>
<script>
import IframeAlert from "@/components/IframeAlert.vue";
import Nav from "@/components/Common/Nav.vue";

export default {
  name: "Desc",
  data: function () {
    return {
      isShowHelp: false,
      url: "",
    };
  },
  components: {
    IframeAlert,
    Nav,
  },
  methods: {
    goHelp: function () {
      let _that = this;
      _that.$router.push("/home/help");
    },
    goBack: function () {
      if (this.isShowHelp) {
        this.hideHelp();
      } else {
        this.$router.back(-1);
      }
    },
    showHelp: function () {
      this.isShowHelp = true;
    },
    hideHelp: function () {
      this.isShowHelp = false;
    },
    backClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/userinfo" });
    },
    openUrl: function (url) {
      let _that = this;
      _that.url = url;
    },
    openNewUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    closeUrl: function () {
      let _that = this;
      _that.url = "";
    },
  },
};
</script>
<style lang="less" scoped>
.help-wrap {
  width: 939px;
  height: 491px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 5px;
  background-color: #ffffff;
  background-image: url(../assets/setting/desc_bg.png);
  background-size: 100% 100%;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 0px rgba(228, 224, 201, 1);
  .back-wrap {
    display: inline-block;
    vertical-align: top;
    padding-left: 22px;
    padding-right: 22px;
    padding-top: 10px;
    width: 88px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    .back-icon {
      display: inline-block;
      margin-top: 10px;
      margin-right: 4px;
      vertical-align: top;
      width: 17px;
      height: 17px;
      background-image: url(../assets/setting/back.svg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .help-middle-wrap {
    text-align: center;
    margin: 0 auto;
    margin-top: 10px;
    width: 620px;
    img {
      width: 100%;
    }
    .help-left-wrap {
      width: 390px;
      display: inline-block;
      vertical-align: top;
      .left-01 {
        width: 388px;
        height: 101px;
        overflow: hidden;
        background-color: #4e9eee;
        background-image: linear-gradient(137deg, #4e9eee 0%, #a8defd 100%);
        background-image: url(../assets/setting/left_01_bg.png);
        background-size: 100% 100%;
        border-radius: 7px 7px 7px 7px;
        position: relative;
        .left-01-title {
          font-size: 20px;
          font-weight: bolder;
          color: #fdfffe;
          line-height: 28px;
          height: 28px;
          text-shadow: 0px 2px 2px rgba(31, 51, 71, 0.4);
          margin-top: 38px;
          margin-left: 80px;
          text-align: left;
        }
        .left-01-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/left_01.svg);
          background-size: 100% 100%;
        }
      }
      .left-right {
        width: 110px;
        display: inline-block;
        vertical-align: top;
        margin-left: 7px;
      }
      .left-02 {
        width: 110px;
        height: 143px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/left_02_bg.png);
        background-size: 100% 100%;
        .left-02-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 14px;
        }
        .left-02-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 20px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-02-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .left-03 {
        width: 110px;
        height: 80px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        text-align: left;
        background-image: url(../assets/setting/left_03_bg.png);
        background-size: 100% 100%;
        .left-03-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 14px;
        }
        .left-03-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-03-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .left-04 {
        width: 270px;
        height: 230px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        text-align: left;
        position: relative;
        background-image: url(../assets/setting/left_04_bg.png);
        background-size: 100% 100%;

        .left-04-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 14px;
        }
        .left-04-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-04-item-wrap {
          margin-left: 20px;
          margin-top: 20px;
          width: 230px;
          height: 140px;
          background-color: rgba(33, 95, 228, 0.08);
          border-radius: 10px;
          text-align: center;
          .left-04-item {
            display: inline-block;
            vertical-align: top;
            width: 60px;
            font-size: 12px;
            color: #2a4178;
            line-height: 14px;
            margin-top: 14px;
            padding-top: 36px;
            background-position: center top;
            background-repeat: no-repeat;
            background-size: 31px 31px;
          }
          .left-04-item-01 {
            background-image: url(../assets/setting/left_04_01.svg);
          }
          .left-04-item-02 {
            background-image: url(../assets/setting/left_04_03.svg);
          }
          .left-04-item-03 {
            background-image: url(../assets/setting/left_04_02.svg);
          }
          .left-04-item-04 {
            background-image: url(../assets/setting/left_04_04.svg);
          }
          .left-04-item-05 {
            background-image: url(../assets/setting/left_04_05.svg);
          }
          .left-04-item-06 {
            background-image: url(../assets/setting/left_04_06.svg);
          }
          .left-04-item-line {
            display: inline-block;
            vertical-align: top;
            width: 1px;
            height: 46px;
            margin-top: 10px;
            margin-left: 5px;
            margin-right: 5px;
            background-color: rgba(246, 249, 254, 0.8);
          }
        }
      }
    }
    .help-right-wrap {
      width: 228px;
      display: inline-block;
      vertical-align: top;
      margin-left: 7px;
      text-align: left;
      .right-01 {
        width: 226px;
        height: 251px;
        overflow: hidden;
        border-radius: 7px 7px 7px 7px;
        position: relative;
        background-image: url(../assets/setting/right_01_bg2.png);
        background-size: 100% 100%;
        .right-01-title {
          font-size: 20px;
          font-weight: bolder;
          color: #fdfffe;
          line-height: 26px;
          text-shadow: 0px 2px 2px rgba(31, 51, 71, 0.4);
          margin-top: 100px;
          // margin-left: 20px;
          text-align: center;
        }
        .right-01-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/right_01.svg);
          background-size: 100% 100%;
        }
      }
      .right-02 {
        width: 110px;
        height: 80px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 6px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_02_bg2.png);
        background-size: 48px 48px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-02-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 14px;
        }
        .right-02-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-02-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }

      .right-03 {
        width: 110px;
        height: 80px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 0px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_03_bg2.png);
        background-size: 48px 48px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-03-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 14px;
        }
        .right-03-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-03-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }

      .right-04 {
        width: 97px;
        height: 99px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_04_bg.svg);
        background-size: 60px 60px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-04-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-04-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-04-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .right-05 {
        width: 177px;
        height: 125px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_05_bg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .right-05-title {
          font-size: 17px;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 20px;
          text-shadow: 0px 2px 2px rgba(9, 12, 45, 0.25);
        }
        .right-05-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/right_05.svg);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .right-06 {
        width: 124px;
        height: 125px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        .right-06-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-06-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .right-06-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
    }
  }
  .more-jdxb {
    position: relative;
    margin: 0 auto;
    margin-top: 10px;
    padding-top: 1px;
    width: 622px;
    height: 48px;
    background-image: linear-gradient(101deg, #e98f3b 7%, #f2c141 84%);
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;

    .more-icon {
      margin-left: 32px;
      margin-top: 15px;
      width: 160px;
      height: 19px;
      background-image: url(../assets/setting/about.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .more-text {
      position: absolute;
      right: 24px;
      top: 0;
      font-size: 14px;
      line-height: 48px;
      color: #fdfffe;
    }
  }
}

.setting {
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
}
</style>
